import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useBackground } from './background-context';
import { BackgroundVariant } from './background-layout';

type BackgroundRouteConfigProps = {
  readonly opacity?: string;
  readonly visible?: boolean;
  readonly variant?: BackgroundVariant;
  readonly ellipse1Variant?: BackgroundVariant;
  readonly ellipse2Variant?: BackgroundVariant;
};

const BackgroundRouteConfig = ({
  opacity,
  visible,
  variant,
  ellipse1Variant,
  ellipse2Variant,
}: BackgroundRouteConfigProps) => {
  const { setBackground, resetBackground } = useBackground();

  useEffect(() => {
    setBackground({ ellipse1Variant, ellipse2Variant, opacity, variant, visible: visible ?? true });
    return () => resetBackground();
  }, [opacity, visible, variant, ellipse1Variant, ellipse2Variant, setBackground, resetBackground]);

  return <Outlet />;
};

export { BackgroundRouteConfig };
